import { Component, OnDestroy, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { PageState } from '@app-core/models/_enums';
import { AppState } from '@app-core/models/app-state';
import { IValidationResponse } from '@app-core/models/validation-response';
import { ApiService } from '@app-core/services/api.service';
import { StateService } from '@app-core/services/state.service';
import { CardDetails } from '@app-pages/models/card-details';
import { Subscription } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

@Component({
  selector: 'app-landings-page',
  templateUrl: './landings-page.component.html',
  styleUrls: ['./landings-page.component.css']
})
export class LandingsPageComponent implements OnDestroy {

  errorDetails: { show: boolean; textOrKey: string } = {
    show: false,
    textOrKey: null
  };
  isLoading: boolean;

  subscriptions = new Subscription();
  cardDetails = new CardDetails();

  @ViewChild('ngForm')
  form: UntypedFormGroup;

  constructor(
    private _apiService: ApiService,
    private _stateService: StateService
  ) {
    this.subscriptions.add(
      this._stateService
        .getState$()
        .pipe(
          filter((currentState: AppState) => currentState.cardDetails != null),
          map((currentState: AppState) => currentState.cardDetails)
        )
        .subscribe(
          (cardDetails: CardDetails) => (this.cardDetails = cardDetails)
        )
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  validate(): void {
    if (!this.validateForm(this.form.controls)) return;

    this.isLoading = true;
    this._apiService
      .validateCardDetails(this.cardDetails)
      .pipe(take(1))
      .subscribe(
        (response: IValidationResponse) => {
          this.isLoading = false;
          this.errorDetails = {
            show: !response.succes,
            textOrKey: response.succes ? null : response.error.message
          };
          if (response.succes) {
            this._stateService.updateState({
              cardDetails: this.cardDetails,
              currentPageState: PageState.UPLOAD_PAGE
            } as AppState);
          }
        },
        () => {
          this.isLoading = false;
          this.errorDetails = { show: true, textOrKey: 'GENERAL.ERROR' };
        }
      );
  }

  validateForm(controls: { [key: string]: AbstractControl }): boolean {
    const boolArray = [this.form.invalid];
    for (const key in controls) {
      if (!controls.hasOwnProperty(key)) continue;
      controls[key].markAsTouched();
      controls[key].markAsDirty();

      boolArray.push(controls[key].invalid);
    }
    return !boolArray.find((value: boolean) => value);
  }
}
